<template>
  <div id="survey-stats">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="row" style="margin: 0">
        <div v-for="(item, index) in data" :key="index" class="col-md-12">
          <div class="card" style="margin: 10px;">
            <span
              style="padding: 10px; font-size: 14px; background-color: whitesmoke; text-align: center"
              >{{ item.title }}</span
            >
            <div
              style="height: 300px;"
              :ref="'chart' + index"
              :id="'chart' + index"
              class="chart"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);
export default {
  components: { PageCountInfo },
  name: "SurveyStats",
  props: ["data"],
  data() {
    return {
      charts: [],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.data.map((item, index) => {
      this.charts.push(am4core.create("chart" + index, am4charts.PieChart));

      this.charts[index].data = item.items.map((i) => {
        return {
          key: i.key,
          value: parseInt(i.value),
        };
      });
      let pieSeries = this.charts[index].series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";

      this.charts[index].pieSeries = pieSeries;
      this.charts[index].legend = new am4charts.Legend();
      this.charts[index].legend.maxWidth = undefined;
      this.charts[index].legend.valueLabels.template.align = "left";
      this.charts[index].legend.valueLabels.template.textAlign = "end";
      this.charts[index].responsive.enabled = true;
    });
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/SurveyStats.vue